import { getAxiosInstance } from '../../dataService';

const getHeaders = ssId => ({
	headers: ssId
		? {
				'X-SS-ID': ssId,
		  }
		: {},
});

// Gets the details about the member's OT action plan
export const fetchOTExercisePlan = async ({ queryKey }) => {
	const [, apiEnv, ssId] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(
			'/memberProgramDetail/occupationalTherapyProgram',
			{
				...getHeaders(ssId),
			}
		)
	).data;
};

// Gets the details about the member's HEP with video transcript
export const fetchOTExercisePlanTranscript = async ({ queryKey }) => {
	const [, apiEnv, ssId, includeTranscript] = queryKey;

	const response = await getAxiosInstance(apiEnv)
		.get('/memberProgramDetail/occupationalTherapyProgram', {
			params: {
				includeTranscript,
			},
			...getHeaders(ssId),
		})
		.catch(error => error);

	return response.name === 'AxiosError' ? response : response.data;
};

// Gets the details for one specific exercise on the HEP previously assigned page.
export const fetchOTExerciseDetails = async ({ queryKey }) => {
	const [, apiEnv, ssId, memberActionItemId] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(
			`/memberActionItem/occupationalTherapyProgram?memberActionItemId=${memberActionItemId}`,
			{
				...getHeaders(ssId),
			}
		)
	).data;
};

export const updateOTFeedback = async (
	apiEnv,
	ssId,
	{ memberActionItemId, selectedRating }
) =>
	(
		await getAxiosInstance(apiEnv).post(
			`/memberActionItemFeedback/occupationalTherapyExercise`,
			{
				memberActionItemId,
				selectedRating,
			},
			{
				...getHeaders(ssId),
			}
		)
	).data;

export const deleteOTFeedback = async (apiEnv, ssId, memberActionItemId) =>
	(
		await getAxiosInstance(apiEnv).delete(
			`/memberActionItemFeedback/occupationaltherapy?memberActionItemId=${memberActionItemId}`,
			{
				...getHeaders(ssId),
			}
		)
	).data;
